/**
 * Premium Audio Engine for Task Players v3
 * Uses REAL MP3 audio files for ambient music
 * Files served from /audio/ directory
 */

// ── Meditation Audio (real MP3 file) ──
export function createMeditationAudio() {
  let audio = null;
  let running = false;

  function start() {
    if (running) return;
    audio = new Audio('/audio/meditation.mp3');
    audio.loop = true;
    audio.volume = 0;
    audio.play().catch(() => {});
    // Fade in
    let vol = 0;
    const fadeIn = setInterval(() => {
      vol = Math.min(vol + 0.02, 0.6);
      if (audio) audio.volume = vol;
      if (vol >= 0.6) clearInterval(fadeIn);
    }, 100);
    running = true;
  }

  function stop() {
    if (!running || !audio) return;
    running = false;
    // Fade out
    const fadeOut = setInterval(() => {
      if (!audio) { clearInterval(fadeOut); return; }
      audio.volume = Math.max(audio.volume - 0.03, 0);
      if (audio.volume <= 0.01) {
        clearInterval(fadeOut);
        audio.pause();
        audio.src = '';
        audio = null;
      }
    }, 100);
  }

  function setVolume(v) {
    if (audio && running) {
      audio.volume = Math.max(0, Math.min(1, v)) * 0.6;
    }
  }

  return { start, stop, setVolume, isRunning: () => running };
}

// ── Breathing Audio (real MP3 file only — no oscillators) ──
export function createBreathingAudio() {
  let audio = null;
  let running = false;

  function start() {
    if (running) return;
    audio = new Audio('/audio/breathing.mp3');
    audio.loop = true;
    audio.volume = 0;
    audio.play().catch(() => {});
    let vol = 0;
    const fadeIn = setInterval(() => {
      vol = Math.min(vol + 0.02, 0.55);
      if (audio) audio.volume = vol;
      if (vol >= 0.55) clearInterval(fadeIn);
    }, 100);
    running = true;
  }

  function setPhase() {
    // Phase changes handled visually; audio stays ambient
  }

  function stop() {
    if (!running || !audio) return;
    running = false;
    const fadeOut = setInterval(() => {
      if (!audio) { clearInterval(fadeOut); return; }
      audio.volume = Math.max(audio.volume - 0.03, 0);
      if (audio.volume <= 0.01) {
        clearInterval(fadeOut);
        audio.pause();
        audio.src = '';
        audio = null;
      }
    }, 100);
  }

  function setVolume(v) {
    if (audio && running) {
      audio.volume = Math.max(0, Math.min(1, v)) * 0.55;
    }
  }

  return { start, stop, setPhase, setVolume, isRunning: () => running };
}

// ── Relaxation Audio (real MP3 file) ──
export function createRelaxationAudio() {
  let audio = null;
  let running = false;

  function start() {
    if (running) return;
    audio = new Audio('/audio/relaxation.mp3');
    audio.loop = true;
    audio.volume = 0;
    audio.play().catch(() => {});
    let vol = 0;
    const fadeIn = setInterval(() => {
      vol = Math.min(vol + 0.02, 0.55);
      if (audio) audio.volume = vol;
      if (vol >= 0.55) clearInterval(fadeIn);
    }, 100);
    running = true;
  }

  function stop() {
    if (!running || !audio) return;
    running = false;
    const fadeOut = setInterval(() => {
      if (!audio) { clearInterval(fadeOut); return; }
      audio.volume = Math.max(audio.volume - 0.03, 0);
      if (audio.volume <= 0.01) {
        clearInterval(fadeOut);
        audio.pause();
        audio.src = '';
        audio = null;
      }
    }, 100);
  }

  function setVolume(v) {
    if (audio && running) {
      audio.volume = Math.max(0, Math.min(1, v)) * 0.55;
    }
  }

  return { start, stop, setVolume, isRunning: () => running };
}
